function DetailsIcon({ color, className, size, onClick }) {
  size = size || "24";
  color = color || "#192048";
  return (
    <svg
      className={className}
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 1 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75zm0-1.125a1.125 1.125 0 1 0-1.123-1.127A1.123 1.123 0 0 0 12 9.373v.003zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0zm9-7.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15z"
        fill={color}
      />
    </svg>
  );
}

export default DetailsIcon;
